import axios from 'axios';


export const saveUrlToBackend = async (url, userId) => {
    try {
      const response = await fetch('/url/save/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          url,
          userId,
        }),
      });

      if (!response.ok) {
        throw new Error('Error saving URL');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  };

  export const fetchUserBlogUrl = async (userId) => {
    const response = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/user/${userId}/blogs/`);
    return response.data.blogs[0].url;
  };

  export const fetchIntegrations = async (blogId) => {
    try {
        const response = await fetch(`https://trendhopper-c3934b7293e6.herokuapp.com/blogs/${blogId}/integrations/`);
        const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching integrations:', error);
      throw error;
    }
}

  export const submitGhostIntegration = async (data) => {
    console.log('submitGhostIntegration', data);
    const response = await axios.post(`https://trendhopper-c3934b7293e6.herokuapp.com/integrate/`, data, {
        headers: { 'Content-Type': 'application/json' },
    });
    return response.status === 200;
  };

  export const createDraftsForBlog = async (url) => {
    try {
        const response = await fetch(`https://trendhopper-c3934b7293e6.herokuapp.com/drafts/create/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          url,
        }),
      });

      console.log('createDraftsForBlog ', response)

      if (!response.ok) {
        throw new Error('Error creating drafts');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  };
